import { getSettingValueWithoutAssignment } from "@faire/deprecated-retailer-visitor-shared/settings/__internal__/getSetting";
import { HCAPTCHA_SITE_KEY } from "@faire/web-api--source/indigofair/settings/HCAPTCHA_SITE_KEY";

export const getSettingHCaptchaKey = (): string =>
  getSettingValueWithoutAssignment(HCAPTCHA_SITE_KEY, "");
